<template>
<!--  <bk-page v-if="0" class="KISIndexPage">-->
<!--    <bk-view class="view-pageBox">-->
<!--      <bk-view class="view-header">-->


<!--        <bk-view class="view-nav">-->
<!--&lt;!&ndash;          <img alt="facebook" data-ssr-src-done="true" fetchpriority="high"&ndash;&gt;-->
<!--&lt;!&ndash;               src="https://static.wixstatic.com/media/4057345bcf57474b96976284050c00df.png/v1/fill/w_56,h_56,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/facebook.png"&ndash;&gt;-->
<!--&lt;!&ndash;               style="width: 28px; height: 28px; object-fit: cover;">&ndash;&gt;-->
<!--&lt;!&ndash;          <img alt="instagram" data-ssr-src-done="true" fetchpriority="high"&ndash;&gt;-->
<!--&lt;!&ndash;               src="https://static.wixstatic.com/media/e1aa082f7c0747168d9cf43e77046142.png/v1/fill/w_56,h_56,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/instagram.png"&ndash;&gt;-->
<!--&lt;!&ndash;               style="width: 28px; height: 28px; object-fit: cover;">&ndash;&gt;-->
<!--        </bk-view>-->


<!--        <bk-view class="view-logo">-->
<!--          <img-->
<!--            src="https://static.wixstatic.com/media/5efe6d_5087d33b163446adab6512ab1739d97e~mv2.png/v1/fill/w_100,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image1.png"-->
<!--            alt="Image1.png" style="width:100px;height:100px;object-fit:cover" width="100" height="100"-->
<!--            srcset="https://static.wixstatic.com/media/5efe6d_5087d33b163446adab6512ab1739d97e~mv2.png/v1/fill/w_100,h_100,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image1.png 1x, https://static.wixstatic.com/media/5efe6d_5087d33b163446adab6512ab1739d97e~mv2.png/v1/fill/w_200,h_200,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Image1.png 2x"-->
<!--            fetchpriority="high">-->
<!--        </bk-view>-->


<!--        <bk-view class="toggle-wrap">-->

<!--          <div class="toggle-btn" @click="openMenu = !openMenu" :class="{ active: openMenu }">-->
<!--            <div class="toggle-btn-line" :class="{ active: openMenu }"></div>-->
<!--            <div class="toggle-btn-line" :class="{ active: openMenu }"></div>-->
<!--            <div class="toggle-btn-line" :class="{ active: openMenu }"></div>-->
<!--          </div>-->

<!--        </bk-view>-->

<!--      </bk-view>-->
<!--      <bk-view class="view-iframe">-->
<!--        <KISWeb :showPage="showPage" :anchors="anchors" @bookBtnClick="bookBtnClick"></KISWeb>-->
<!--      </bk-view>-->

<!--      <van-popup-->
<!--        v-model:show="openMenu"-->
<!--        position="right"-->
<!--        :style="{ width: '50%', height: '100%' }"-->
<!--      >-->
<!--        <bk-view class="view-menu">-->
<!--          <bk-view class="toggle-wrap toggle">-->

<!--            <div class="toggle-btn active" @click="openMenu = !openMenu">-->
<!--              <div class="toggle-btn-line active" ></div>-->
<!--              <div class="toggle-btn-line active" ></div>-->
<!--              <div class="toggle-btn-line active" ></div>-->
<!--            </div>-->

<!--          </bk-view>-->


<!--          <bk-button :color="showPage==='KisHome'?'#f2bd1e':'#000000'" type="text" @click="()=>goToHome('')">Home-->
<!--          </bk-button>-->
<!--          <bk-button type="text" @click="()=>goToHome('about')">About</bk-button>-->
<!--          <bk-button :color="showPage==='SalonPriceList'?'#f2bd1e':'#000000'" type="text" @click="goToSalonPrice">Salon-->
<!--            Price List-->
<!--          </bk-button>-->
<!--          <bk-button type="text" @click="()=>goToHome('gallery')">Gallery</bk-button>-->
<!--          <bk-button :color="showPage==='Products'?'#f2bd1e':'#000000'" type="text" @click="goToProduct">Products-->
<!--          </bk-button>-->
<!--          <bk-button type="text" @click="bookBtnClick">Book Now</bk-button>-->
<!--          &lt;!&ndash;          <bk-button type="text" @click="()=>goToHome('product')">Products</bk-button>&ndash;&gt;-->

<!--        </bk-view>-->

<!--      </van-popup>-->
<!--    </bk-view>-->

<!--&lt;!&ndash;    <transition name="rightFadeIn" mode="out-in">&ndash;&gt;-->
<!--&lt;!&ndash;      <KISRoot v-if="showResFlag" @close="showResFlag=false"></KISRoot>&ndash;&gt;-->
<!--&lt;!&ndash;    </transition>&ndash;&gt;-->

<!--  </bk-page>-->

  <bk-page v-if="!tempShopInfo" :loading="true" class="KISLoadPage">

  </bk-page>

  <SwitchStore v-else :shop-info="tempShopInfo" hideBackFlag @action="shopAction">

  </SwitchStore>


</template>

<script>

	import KISRoot from '/src/pages/root/KISRoot.vue';
	import SwitchStore from '../reserve/subViews/storeInfo/switchStore/switchStore.vue';
	import KISWeb from './subviews/KISWeb.vue';

	import { authReq } from '@/reqService';
	import {shopReq} from '../../reqService';

	export default {
		name: 'KISIndex',
		components: {
			KISRoot,
			KISWeb,
			SwitchStore
		},
		computed: {},
		data () {
			return {
				iframeUrl: 'https://www.kishair.com.au/',
				// iframeUrl: 'https://kis-book.mase.cloud/kis-web.html',
				showPage: 'KisHome',
				anchors: '',
				showResFlag: false,
				openMenu: false,

				tempShopInfo: undefined,
			};
		},
		async created () {
			document.title = 'KIS Hair - Melbourne | Haircuts and Hairdressing';
		
			let reloadPath = '/';

			if (window.reloadPath) {
				reloadPath = window.reloadPath;
				delete window.reloadPath;
			}
			
			if (this.$bk_getAccessToken() && this.$bk_getAccessToken() != '') {
				let userInfo = await authReq.requestGetUserInfoByToken(this, {}).catch(() => {});

				if (!userInfo) {
					this.$bk_setAccessToken(undefined);
				}
				bkLog.log('Index_userInfo:', userInfo);

				if (userInfo) {
					userInfo.id = userInfo.id || userInfo.userId;

					if (userInfo.language && userInfo.language.languageCode) {
						this.$bk_switchLang(userInfo.language.languageCode);
					}
					this.$bk_setUserInfo(userInfo);
				} else {
					this.$bk_setAccessToken(undefined);
				}
			}

			this.requestInitData();

			// this.$router.replace(reloadPath);
		},
		methods: {


			shopAction (e) {

				bkLog.log('shopAction:::', e);

				if (e?.key == 'switchStore') {

					let {item} = e;

					localStorage.setItem('kis-cacheShopInfo', JSON.stringify({
						id: item.id,
						custId: item.custId,
						compCode: item.compCode,
						name: item.compName || item.name,
						compName: item.compName || item.name,
					}));


					this.$router.replace(`/shopDetail?custId=${item.custId}&compId=` + item.id);
				}

			},

			async requestInitData () {
				let cacheShopInfo = localStorage.getItem('kis-cacheShopInfo');
        
				if (!cacheShopInfo) {

					// KISHAIR
					let chainInfo = await shopReq.requestGetChainInfoByKeyword(this, {custId: 'KISHAIR'}).catch(() => {});

					chainInfo.canReserveCompanyList = chainInfo.companyList.filter((item) => {
						// 对外可预约 没过期
						return item.canReserve===1 && !item.compExpired;
					});

					bkLog.log('返回的缓存连锁信息ABC:', chainInfo);

					console.log('chainInfo.canReserveCompanyList:::', chainInfo.canReserveCompanyList);

					// cacheShopInfo = chainInfo.canReserveCompanyList[0];


					this.tempShopInfo = chainInfo;
					return;

          
				} else {
					cacheShopInfo = JSON.parse(cacheShopInfo);
				}

				bkLog.error('cacheShopInfo:::', cacheShopInfo);
				
				this.$router.replace(`/shopDetail?custId=${cacheShopInfo.custId}&compId=` + cacheShopInfo.id);
			},

			goToHome (anchor = '') {
				this.anchors = anchor;
				this.showPage = 'KisHome';
				this.openMenu = false;
			},
			goToProduct () {
				this.showPage = 'Products';
				this.anchors = '';
				this.openMenu = false;
			},
			goToSalonPrice () {
				this.showPage = 'SalonPriceList';
				this.anchors = '';
				this.openMenu = false;
			},
			bookBtnClick () {

				this.$router.push('/shopDetail?custId=KISHAIR&compId=483351635912097793');

				// this.showResFlag = true;
				this.anchors = '';
				// this.showPage = 'KisHome';
				this.openMenu = false;
			},
		}
	};
</script>

<style lang="less">


.KISLoadPage {
  height: 100vh !important;
  .configImgUrlBc('Def_KIS_C_LoginBC.png', @color-bc-def, center top / 100% 100% no-repeat) !important;
}

.KISIndexPage {
  height: 100vh !important;
  background: #fff;

  @font-face {
    font-family: futura-lt-w01-light;
    src: url('https://static-global.boka.vc/mase/customer/futura-lt-w01-light.woff2') format('woff2');
  }
  @font-face {
    font-family: didot-w01-italic;
    src: url('https://static-global.boka.vc/mase/customer/didot-w01-italic.woff2') format('woff2');
  }

  .view-pageBox {
    height: 100%;
    --site-width: 320px;


    > .view-header {
      padding: calc(12px + env(safe-area-inset-top)) 16px 12px 16px;
      min-height: calc(64px + env(safe-area-inset-top));
      display: flex;
      justify-content: space-between;

      > .view-nav {
        img + img {
          margin-left: 12px;
        }
      }
    }

    > .view-iframe {
      width: 100%;
      //height: calc(100% - env(safe-area-inset-top) - 64px);
      min-height: calc(100% - env(safe-area-inset-top) - 64px);
    }
  }

  .view-menu {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 120px 12px;
    position: relative;

    .toggle{
      position: absolute;
      top: calc(env(safe-area-inset-top) + 20px);
      right: 12px;
    }

    .bk-button {
      font-size: 20px;
      color: #000000;

      & + .bk-button {
        margin-top: 20px;
      }

    }
  }
}

</style>

<style scoped>
.toggle-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;
  position: relative;
}

.toggle-btn-line {
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background-color: #000;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.toggle-btn-line:nth-child(1) {
  transform: translateY(0);
}

.toggle-btn-line:nth-child(2) {
  transform: translateY(0);
}

.toggle-btn-line:nth-child(3) {
  transform: translateY(0);
}

.toggle-btn.active .toggle-btn-line:nth-child(1) {
  transform: translateY(9px) rotate(-45deg);
}

.toggle-btn.active .toggle-btn-line:nth-child(2) {
  opacity: 0;
}

.toggle-btn.active .toggle-btn-line:nth-child(3) {
  transform: translateY(-9px) rotate(45deg);
}
</style>
